import axios from 'axios'

// set config api
const ApiConfig = {
  getDataCn: { url: '/allshow_cn.json', method: 'get' },
  getDataEn: { url: '/allshow_en.json', method: 'get' }
}

function parseUrl(url, paramsData, submitData) {
  let baseUrl = url || ''
  let params = paramsData || {}
  let paramsType = Object.prototype.toString.call(params)
  let reg = new RegExp('{.*?}', 'g')
  let matches = baseUrl.match(reg)
  if (matches) {
    if (paramsType !== '[object Object]') {
      throw new Error('paramsData should be a object')
    }
    let cpParams = Object.assign({}, params)
    for (let i = 0; i < matches.length; i++) {
      let key = matches[i].replace(/\{|\}/g, '')
      if (cpParams[key] !== '' && cpParams[key] !== undefined) {
        let regItem = new RegExp(matches[i], 'g')
        baseUrl = baseUrl.replace(regItem, cpParams[key])
        delete cpParams[key]
      } else {
        throw new Error('error url params: ' + key + ' not in paramsData')
      }
    }
    if (submitData) {
      return { baseUrl: baseUrl, data: submitData }
    } else {
      return { baseUrl: baseUrl, data: cpParams }
    }
  } else {
    return { baseUrl: baseUrl, data: params }
  }
}

const instance = axios.create({
  baseURL: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024',
  // baseURL: window.location.href.indexOf('47.103.36.224') === -1 ? '/api' : 'https://qingbohui2022.oss-cn-shanghai.aliyuncs.com/api',
  timeout: 60000
})

/**
 * 
 * @param {String} resourceName ApiConfig里面的key
 * @param {Object} paramsData 用来替换url参数的dict
 *         如: ApiConfig 里面的url 为：'api/somerequest/{id}'时，传递{id: 2}, 生成请求地址api/somerequest/2
 * @param {Object} submitData 提交的数据
 */
function ApiResource(resourceName, paramsData, submitData) {
  if (!ApiConfig[resourceName]) {
    throw new Error('no these api: ' + resourceName + ' resouce')
  }
  let url = ApiConfig[resourceName].url
  let getParams = parseUrl(url, paramsData, submitData)
  let methodType = ApiConfig[resourceName].method

  let request = {
    url: getParams.baseUrl,
    method: methodType
  }
  let headers = null
  if (getParams.data._headers) {
    headers = getParams.data._headers
    delete getParams.data._headers
  }
  if (methodType === 'post' || methodType === 'put' || methodType === 'patch') {
    request.data = getParams.data._fileData ? getParams.data._fileData : getParams.data
  } else {
    let params = getParams.data
    if (methodType === 'get') {
      params._timeTag = new Date().valueOf()
    }
    request.params = params
  }
  if (headers) {
    for (let key in headers) {
      request.headers[key] = headers[key]
    }
  }
  return instance.request(request)
}

export default ApiResource